import { FIND_TAGS_REQUEST, findTagsSuccess, findTagsFailure } from 'Redux/Action';
import { ofType } from 'redux-observable';
import { from } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { TEpic } from "Redux/Config";

export const findTagsEpic: TEpic = (action$, store$, { TagRepository }) => {
    return action$.pipe(
        ofType( FIND_TAGS_REQUEST ),
        mergeMap(action => from(
            TagRepository.findAll(action.payload)
                .then(({ tags, meta }) => findTagsSuccess({ tags, response: meta, request: action}))
                .catch((error: Error) => findTagsFailure(error)),
        )),
    );
}
